import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';
import { AddMessageTemplateApiModel, TemplateValidationModel } from './MessageTemplateModel';

@Service()
export default class MessageTemplateService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async post(model: AddMessageTemplateApiModel) {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/message-template';
            const result = await this.axiosService.axiosInstance.post(url, model);
            this.loaderService.HideLoader();
            return result.data;
        } catch (error) {
            this.loaderService.HideLoader();
            return false;
        }
    }    
    public async ConnectingSenderName(senderName: string, crNumber: string, customerType: number, enterpriseUnifiedNumber: string,): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/senders/get-sender-for-message-template-request?'
                + 'senderName=' + encodeURIComponent(senderName || '')
                + '&crNumber=' + encodeURIComponent(crNumber || '')
                + '&customerType=' + customerType
                + '&enterpriseUnifiedNumber=' + encodeURIComponent(enterpriseUnifiedNumber || '');
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async getActiveRegulations(category: number): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/regtech/regulations/active?category=' + category;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return { isSuccess: false, errorMessage: 'Request failed' };
        }
    }

    public async getPreApprovedTemplates(classification: number): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/pre-approved-template/by-classification/' + classification;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return { isSuccess: false, result: [], errorMessage: 'Failed to load suggested templates' };
        }
    }

    public async checkMessageTemplate(validationModel: TemplateValidationModel): Promise<any> {
        try {
            const url = window.$config.HostName + 'api/message-template/check';
            const result = await this.axiosService.axiosInstance.post(
                url,
                validationModel,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }
            );
            return result.data;
        } catch (exception) {
            console.error(exception);
            return {
                isSuccess: false,
                result: null,
                errorMessage: 'API call failed'
            };
        }
    }       
}
